export default function openApp({
  address,
  title = "全球战疫大事记 - 南方+"
}) {
  const params = {
    id: 12,
    shareType: "share",
    title,
    isActivity: true,
    address,
    needClipboard: true
  }
  console.log(params)
  window.OpenApp(params)
}